import { forwardRef, type Ref, type SVGProps } from "react";
const IconMapDrawFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m27 8.89-2 2v14.8l-5 1.93V15.88l-2 2v9.8l-7-2.34V8.38l6.36 2.38L22 10 10.14 6.05a.54.54 0 0 0-.28 0L3.45 7.59A2 2 0 0 0 2 9.51v16.84a2 2 0 0 0 2 2 2.2 2.2 0 0 0 .55-.08L9.86 27a.6.6 0 0 1 .27 0l8.7 2.9a.47.47 0 0 0 .33 0l6.63-2.42a2 2 0 0 0 1.21-1.8zM9 25.22l-5 1.13V9.51l5-1.26z" />
    <path d="M13.64 14.49a.42.42 0 0 0-.14.28l-.5 3.45a.69.69 0 0 0 .19.58.67.67 0 0 0 .48.2l3.55-.5a.42.42 0 0 0 .28-.14l.49-.49L29.8 6.08a.68.68 0 0 0 0-1L26.89 2.2a.67.67 0 0 0-.48-.2.7.7 0 0 0-.49.2z" />
  </svg>
);
const ForwardRef = forwardRef(IconMapDrawFilledSVG);
ForwardRef.displayName = "IconMapDrawFilled";
export { ForwardRef as IconMapDrawFilled };
